module.exports = require.ensure([
  './input-maxlength.amd.vue'
], function () {
  return require('./input-maxlength.amd.vue');
});



// WEBPACK FOOTER //
// ./app/components/molecules/input-maxlength/input-maxlength.amd.js